import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import StudentDashboardStats from '@/models/StudentDashboard';
import { ListCourseProgressFilters } from './courseProgressServices';

export type StudentDashboardFilters = ListCourseProgressFilters & {
  studentId?: number;
};

const courseProgressPath = 'course-progress';

export const dashboardPath = 'dashboard';

export async function listStudentDashboardStats(
  params?: StudentDashboardFilters,
) {
  const { data } = await requester().get<
    JsonApiResponse<StudentDashboardStats>
  >(`${courseProgressPath}/${dashboardPath}/`, {
    params,
  });

  return data;
}
